import React, { FC } from 'react';
import styled from 'styled-components';
import { useLibraryManagedProductGroupsFeaturePages } from '../marketing/productgroups/api/useLibraryManagedProductGroupsFeaturePages';
import { mapProductGroup } from '../marketing/productgroups/mapProductGroup';
import { getLocalisedProductGroupTitle } from '../marketing/productgroups/detail/mappers';
import { useTranslation } from 'react-i18next';

const StProductGroupNav = styled.ul`
    line-height: 22px;
    display: flex;
    font-size: 16px;
`;

export const ProductGroupDetailNavigation: FC<{ id: string }> = ({ id }) => {
    const {
        i18n: { language }
    } = useTranslation();
    const { data: featuredPages } = useLibraryManagedProductGroupsFeaturePages();
    const productGroup = mapProductGroup(featuredPages, parseInt(id));
    const title = getLocalisedProductGroupTitle(productGroup?.titles, language);

    return (
        <StProductGroupNav>
            <li>
                <span>Product Groups</span>
            </li>
            <li>
                <i className="material-icons big">keyboard_arrow_right</i>
            </li>
            <li>
                <span>{title}</span>
            </li>
        </StProductGroupNav>
    );
};
